import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../stylesheets/resource.scss";
import { Col, FormGroup, Label } from "reactstrap";
import { Formik } from "formik";
import axios from "axios";
import { CM_APIs } from "./CM_APIs";
import { UserConsumer } from "../../../UserContext";
import PageLoader from "../../../components/PageLoader";
import { goBackFunction } from "../../../utils";
import moment from "moment";
import FormStatus from "../../../components/FormStatus";
import { Config, Routes } from "../../../configurations/config";
let token = null;

class TicketDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			date: new Date().toDateString(),
			ticketDetails: {},
			deptComments: "",
			cmComments: "",
			showLoader: true,
			attachment: "",
		};
		this.goBack = this.goBack.bind(this);
	}
	componentDidMount() {
		const headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${CM_APIs.CMTicketDetails_API}${this.props.match.params.ticketId}`,
				{ headers: headers }
			)
			.then((res) => {
				this.setState({
					showLoader: false,
					ticketDetails: res.data.ticket,
					deptComments: this.getRecentDeptComment(res.data.comments),
					cmComments: this.getRecentCMComment(res.data.comments),
					attachment: res.data.ticket.attachedFileName,
				});
			});
	}

	goBack = () => {
		goBackFunction(Routes.MyTickets, this.props.history);
	};
	getRecentDeptComment = (comments) => {
		let deptComment = "";
		if (comments.length !== 0) {
			for (let element of comments) {
				if (!element.isCMComment) deptComment = element.ticketComment;
			}
			return deptComment;
		} else return "";
	};
	getRecentCMComment = (comments) => {
		let cmComment = "";
		if (comments.length !== 0) {
			for (let element of comments) {
				if (element.isCMComment) cmComment = element.ticketComment;
			}
			return cmComment;
		} else return "";
	};
	render() {
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					if (this.state.showLoader) {
						return <PageLoader />;
					} else
						return (
							<div className="container-fluid pl-3 pr-3">
								<FormStatus
									title="Ticket Detail"
									formStatus={
										this.state.ticketDetails.status === 0
											? "Pending"
											: this.state.ticketDetails
													.status === 1
											? "In Progress"
											: this.state.ticketDetails
													.status === 2
											? "Completed"
											: this.state.ticketDetails
													.status === 3
											? "Rejected"
											: this.state.ticketDetails.status
									}
									className="create-request d-flex align-items-center"
									onClick={this.goBack}
									navigateBack={true}
								/>

								<Formik initialValues={this.ticketDetails}>
									<form className=" detailsScreen  ">
										<FormGroup
											id="row0"
											className="form-group mb-0 row topBorders"
										>
											<Label sm={12}>
												Ticket id#{" "}
												{
													this.props.match.params
														.ticketId
												}
											</Label>
										</FormGroup>
										<FormGroup
											row
											sm={12}
											className="bottom-spacing row1 mb-0"
										>
											<Label sm={3}>Item Name:</Label>
											<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
												<span
													sm={3}
													className="dataSpan"
												>
													{this.state.ticketDetails
														.itemName === null
														? this.state
																.ticketDetails
																.alternateTicketItem
														: this.state
																.ticketDetails
																.itemName}
												</span>
											</div>
											<Label sm={3}>Created By:</Label>
											<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
												<span className="dataSpan">
													{
														this.state.ticketDetails
															.creator
													}
												</span>
											</div>
										</FormGroup>
										<FormGroup
											row
											sm={12}
											className="bottom-spacing row2 mb-0"
										>
											<Label sm={3}>Assigned To:</Label>
											<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
												<span
													sm={3}
													className="dataSpan"
												>
													{" "}
													{
														this.state.ticketDetails
															.department
													}
												</span>
											</div>
											<Label htmlFor="Person" sm={3}>
												Person:
											</Label>
											{this.state.ticketDetails
												.assignee == null && (
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
													<span
														sm={3}
														className="dataSpan"
													>
														No assignee person{" "}
													</span>
												</div>
											)}
											{this.state.ticketDetails
												.assignee != null && (
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
													<span
														sm={3}
														className="dataSpan"
													>
														{
															this.state
																.ticketDetails
																.assignee
														}
													</span>
												</div>
											)}
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing row1 mb-0"
										>
											<Label sm={3}>Status:</Label>
											<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
												<span
													sm={3}
													className="dataSpan"
												>
													{this.state.ticketDetails
														.status === 0
														? "Pending"
														: this.state
																.ticketDetails
																.status === 1
														? "In Progress"
														: this.state
																.ticketDetails
																.status === 2
														? "Completed"
														: this.state
																.ticketDetails
																.status === 3
														? "Rejected"
														: this.state
																.ticketDetails
																.status}
												</span>
											</div>
											<Label sm={3}>Priority</Label>
											<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
												<span className="dataSpan">
													{this.state.ticketDetails
														.priority === 0
														? "High"
														: this.state
																.ticketDetails
																.priority === 1
														? "Medium"
														: this.state
																.ticketDetails
																.priority === 2
														? "Low"
														: this.state
																.ticketDetails
																.priority}
												</span>
											</div>
										</FormGroup>
										<FormGroup
											row
											className="bottom-spacing row2 bottomBorders mb-0"
										>
											<Label sm={3}>Request Date</Label>
											<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
												<span className="dataSpan">
													{moment(
														this.state.ticketDetails
															.requestDate
													).format("DD/MM/yyyy")}
												</span>
											</div>
											<Label sm={3}>Description:</Label>
											<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow description">
												<span
													sm={3}
													className="dataSpan"
												>
													{" "}
													{
														this.state.ticketDetails
															.details
													}
												</span>
											</div>
										</FormGroup>
										{this.state.deptComments.trim() !==
											"" && (
											<FormGroup
												row
												className="bottom-spacing row1 mb-0"
											>
												<Label sm={3}>
													Department comments
												</Label>
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow description">
													<span
														sm={9}
														className="dataSpan"
													>
														{
															this.state
																.deptComments
														}
													</span>
												</div>
											</FormGroup>
										)}
										{this.state.cmComments.trim() !==
											"" && (
											<FormGroup
												row
												className="bottom-spacing row2 "
											>
												<Label sm={3}>
													CM comments
												</Label>
												<div className="col-sm-3 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow">
													<span
														sm={9}
														className="dataSpan"
													>
														{this.state.cmComments}
													</span>
												</div>
											</FormGroup>
										)}
										<FormGroup
											row
											className="bottom-spacing row1 bottomBorders mb-0"
										>
											<Label sm={3}>Attachment</Label>
											<div className="col-sm-9 mb-3 mb-lg-0 mb-md-0 mt-2 textOverflow description">
												{this.state.attachment != "" ? (
													<Col
														sm={9}
														className="pl-0 ml-0"
													>
														<div>
															<a
																id="imageName"
																href={`${Config.server_url}/${this.state.attachment}`}
																target="_blank"
																rel="noopener noreferrer"
																className="link"
																style={{
																	textDecoration:
																		"underline",
																	fontWeight:
																		"normal",
																}}
															>
																{this.state.ticketDetails.attachedFileName.slice(
																	20,
																	70
																)}
															</a>
														</div>
													</Col>
												) : (
													"N/A"
												)}
											</div>
										</FormGroup>
									</form>
								</Formik>
							</div>
						);
				}}
			</UserConsumer>
		);
	}
}
export default TicketDetails;
